// removed by extract-text-webpack-plugin
module.exports = {"singleRating":"_2O1PG9rSxoO3OgX0NWQ1Yg","star":"_3vDqfazndzkjgAvNHz_R6p","active":"_3rg-U3vZLhZRAydLVQxTiC","inactive":"_3vubpYR28afeuSGESQipWX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Main/SingleRating.css
// module id = 1327
// module chunks = 0